import React, { ForwardedRef, ReactNode, forwardRef } from 'react'
import { CSSTransition } from 'react-transition-group'

interface FadeTransitionProps {
	in?: boolean
	timeout: number
	children: ReactNode
}

const FadeTransition = forwardRef(
	(props: FadeTransitionProps, ref: ForwardedRef<HTMLDivElement>) => {
		FadeTransition.displayName = 'FadeTransition'

		return (
			<CSSTransition
				in={props.in}
				timeout={props.timeout}
				unmountOnExit={true}
				classNames="fade"
				nodeRef={ref}
			>
				{props.children}
			</CSSTransition>
		)
	}
)
export default React.memo(FadeTransition)
